export const visit = (vm, at) => {
at({ "zh-tw": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "\u62B1\u6B49\uFF0C\u6211\u5011\u7121\u6CD5\u9A57\u8B49\u4F60\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u3002" } } } });
};